import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import LogoTop from '../../assets/Images/logo-top.png'; // Correctly import the logo-top.png

const AuthLayout = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(-47deg, #24b0bc 0%, #0792df 100%)", // Applied the new gradient background
        position: "relative",
        overflow: "hidden", // Hide any overflow from patterns if added later
      }}
    >
      {/* Main Content Card */}
      <Box
        sx={{
          backgroundColor: theme.palette.background.paper,
          borderRadius: 4, // Apply border-radius to all corners of the card
          boxShadow: theme.customShadows.z24,
          p: 4,
          width: { xs: "90%", sm: 400 }, // Responsive width
          maxWidth: 400,
          textAlign: "center",
          position: "relative",
          zIndex: 1,
          // Adjust padding-top and padding-bottom to make space for the overlapping logo and consistent vertical padding
          pt: 10, // Increased padding-top to accommodate the logo
          pb: 10, // Set padding-bottom to match padding-top
        }}
      >
        {/* Logo Container - positioned to overlap the top of the card */}
        <Box
          sx={{
            position: "absolute",
            top: 0, // Align top edge with the card's top edge
            left: "50%",
            transform: "translate(-50%, -50%)", // Pull it up by half its height
            zIndex: 2,
            backgroundColor: theme.palette.background.paper,
            borderRadius: "50%",
            width: 120,
            height: 120,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // Removed boxShadow from here
          }}
        >
          <img src={LogoTop} alt="Chat App Logo" style={{ width: 80, height: 80 }} />
        </Box>


        {/* Outlet for the form content */}
        <Outlet />
      </Box>
    </Box>
  );
};

export default AuthLayout;